module.exports = __webpack_public_path__ + "static/media/102.627c29b1.jpg";